import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IconComponent {
  @Input() svgIcon?: string;
  @Input() class?: string;

  @Input() badge: string = '\u200B';
  @Input() badgeHidden: boolean = true;
  @Input() isFlexBox: boolean = true;

  constructor() {}
}
